import { useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function ReportsRedemptionLogsTable() {

  const navigate = useNavigate();
  const [rows] = useState([
    {
      id: 1,
      name: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      phone: "+91 9876543210",
      type: "Promotion",
      itemName: "Summer Sale 2025",
      pointsUsed: 150,
      redeemedOn: "04-Sep-2025 11:30 AM",
      status: "Successful",
    },
    {
      id: 2,
      name: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      phone: "+91 9876543210",
      type: "Reward",
      itemName: "Amazon Gift Card",
      pointsUsed: 500,
      redeemedOn: "03-Sep-2025 05:20 PM",
      status: "Pending",
    },
    {
      id: 3,
      name: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      phone: "+91 9876543210",
      type: "Promotion",
      itemName: "Festival Discount",
      pointsUsed: 200,
      redeemedOn: "02-Sep-2025 02:05 PM",
      status: "Failed",
    },
  ]);

  return (
    <TableContainer className="table_container">
      <Table>
        <TableHead>
          <TableRow hover>
            <TableCell>User</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Promotion / Reward</TableCell>
            <TableCell>Points Used</TableCell>
            <TableCell>Redeemed On</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow hover key={row.id}>
              <TableCell>
                <Box
                  component="a"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/manage-users/detail");
                  }}
                  className="user_block click_action"
                >
                  <p>
                    <b>{row.name}</b>
                    <span>{row.email}</span>
                    <span>{row.phone}</span>
                  </p>
                </Box>
              </TableCell>
              <TableCell>{row.type}</TableCell>
              <TableCell>{row.itemName}</TableCell>
              <TableCell>{row.pointsUsed}</TableCell>
              <TableCell>{row.redeemedOn}</TableCell>
              <TableCell>
                <span
                  className={`status_btn dark ${row.status === "Successful"
                    ? "c_success"
                    : row.status === "Pending"
                      ? "c_warning"
                      : row.status === "Failed"
                        ? "c_danger"
                        : "c_default"
                    }`}
                >
                  {row.status}
                </span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
